import HttpService from "~/Scripts/services/httpService";

const instance = new HttpService( "umbraco/api/MetaDataApi/" );

/* eslint-disable arrow-body-style */

/**
 * Load meta data configuration
 *
 * @param {Number} objectId The ID of the object we are loading meta data for
 * @param {GUID} containerId The container ID to load (NULL to load all containers)
 * @param {Number} recordTypeId The record type ID to use.
 * @param {GUID} pkValue The primary key to load existing meta data values
 * @param {Boolean} blankOnly The true and we are loading existing meta dat avalues, only values
 *                              that have not been populated will be returned
 */
export const metaDataConfig = ( objectId, containerId, recordTypeId, pkValue, blankOnly ) => {
  // pkValue is a string so passing undefined or null will pass the word "undefined" or "null",
  // this breaks the site as the controller does not understand this, so we make sure undefine
  // or null are converted to a blank string
  const convertedPkValue = pkValue || "";
  return instance.get( `MetaDataConfig?objectId=${objectId}&containerId=${containerId}&recordTypeId=${recordTypeId}&pkValue=${convertedPkValue}&blankOnly=${blankOnly}` );
};
